import { IRawData, ITreeNode } from "./interfaces"

export * from "./filter"

const queryTreeSort = (datas: IRawData[]): IRawData[] => {
  const ri: string[] = []
  const indexById = {}
  const childsById = {}
  const sortedDatas = []

  datas
    .sort((a, b) => a.name.localeCompare(b.name))
    .forEach((element, i) => {
      indexById[element.id] = i
      if (childsById[element.fatherId] == null) {
        childsById[element.fatherId] = []
      }
      if (element.fatherId === "" || element.fatherId === "NULL") {
        ri.push(element.id.toString())
      }
      childsById[element.fatherId].push(element.id)
    })

  // Depth-first pre-order walk with a stack (same order as before: a node, then its children in name order,
  // then its next sibling). The former queue was copied (splice + concat) for every node: O(n²) at startup.
  const stack: Array<string | number> = [...ri].reverse()
  while (stack.length) {
    const thisid = stack.pop() as string | number
    sortedDatas.push(datas[indexById[thisid]])
    const children: Array<string | number> | undefined = childsById[thisid]
    if (children != null) {
      for (let i = children.length - 1; i >= 0; i--) {
        stack.push(children[i])
      }
    }
  }
  return sortedDatas
}

const makeTree = (datas: any[]): ITreeNode[] => {
  const temp = {}
  const tree: ITreeNode[] = []

  datas.forEach((jsonElement) => {
    temp[jsonElement.id] = jsonElement
    const father = temp[jsonElement.fatherId]

    if (father != null) {
      const parentPath = father.path === undefined ? "" : father.path
      temp[jsonElement.id].path =
        parentPath +
        (parentPath !== "" ? " / " : "") +
        temp[jsonElement.id].name
      if (father.children === undefined) {
        father.children = []
      }
      father.children.push(jsonElement)
    } else {
      jsonElement.path = ""
      tree.push(jsonElement)
    }
  })

  return tree
}

export const result = (rawDataa: IRawData[]): ITreeNode => {
  const sortedData = queryTreeSort(rawDataa)
  const tree = makeTree(sortedData)
  return tree[0]
}

export const searchNodeByValue = <T extends ITreeNode>(
  tree: ITreeNode[] | ITreeNode,
  matchingValue: string
): T | undefined => {
  if (Array.isArray(tree)) {
    let i
    let r
    for (i = 0; r === undefined && i < tree.length; i++) {
      r = searchNodeByValue<T>(tree[i], matchingValue)
    }
    return r
  } else if (tree.value + "" === matchingValue + "") {
    return tree as T
  } else if (tree.children !== undefined) {
    return searchNodeByValue<T>(tree.children as T[], matchingValue)
  }
  return undefined
}

export const searchNodeByCode = <T extends ITreeNode>(
  tree: ITreeNode[] | ITreeNode,
  matchingCode: string
): T | undefined => {
  if (Array.isArray(tree)) {
    let i
    let r
    for (i = 0; r === undefined && i < tree.length; i++) {
      r = searchNodeByCode<T>(tree[i], matchingCode)
    }
    return r
  } else if (tree.code + "" === matchingCode + "") {
    return tree as T
  } else if (tree.children !== undefined) {
    return searchNodeByCode<T>(tree.children as T[], matchingCode)
  }
  return undefined
}
